export const API_CREDENTIALS = {
  email: "HOMEPAGE@MRIS.CL",
  password: "u6.nLr4VSeU3MhEYM.vA1",
};
